<!--  for capps logo - add class "isCappsHeader" for <header>  -->
<!--  for HDFC logo - remove class "isCappsHeader" for <header>  -->
<header class="common-header" [ngClass]="{'isCappsHeader':isCappsHeader}">
	<div class="container">
		<div class="row align-items-center">
			<div class="col-sm-12">
				<img src="assets/images/hdfc-logo.svg" alt="HDFC EKYC" class="logo-img HDFCLogo" />	
				<!-- <img src="assets/images/cappsLogo.png" alt="HDFC EKYC" class="logo-img cappsLogo"/>			 -->
			</div>
		</div>
	</div>
</header>
